import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Col,
} from "reactstrap";
import { connect } from "react-redux";
import "./Quotation.scss";
import AllInGatePass from "./AllInGatePass";
import FiltertRightbar from "./FiltersRightbar";

import {
  getIGPList,
  SetParams,
  FilterChangeValue,
  FilterClear,
  FiltersShowRightSidebar,
} from "../../store/ingatepass/actions";
import LoadingModel from "../LoadingModel";

class QuotationDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    this.props.FilterClear();

    this.props.getIGPList({
      ...this.props.params,
      // pistatus: [0],
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      department: "",
      grn2items__product: "",
    });
    this.props.SetParams({
      ...this.props.params,
      // mrstatus: [0],
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      department: "",
      grn2items__product: "",
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}

            <Row>
              <Col lg={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom ">
                    <h5 className="card-title-18 pt-2 d-inline-block">
                      In Gate Pass Dashboard
                    </h5>
                    <div className="float-right">
                      <div className="d-inline-block">
                        <Button
                          type="button"
                          color="light"
                          className="waves-effect waves-light d-flex  mr-2"
                          onClick={() => this.props.FiltersShowRightSidebar()}
                        >
                          <i className="mdi mdi-filter"></i>
                          <span className="d-none d-lg-block ml-1">
                            Filters
                          </span>
                        </Button>
                      </div>
                      <Button
                        type="button"
                        color="primary"
                        className="waves-effect waves-light"
                        href="/newigp/0"
                      >
                        New IGP
                      </Button>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-0">
                    <AllInGatePass />
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <FiltertRightbar />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
const mapStatetoProps = (state) => {
  const { params, loading } = state.ingatepass;
  return {
    params,
    loading,
  };
};

export default connect(mapStatetoProps, {
  getIGPList,
  SetParams,
  FilterChangeValue,
  FilterClear,
  FiltersShowRightSidebar,
})(QuotationDashboard);
